function Contact() {
  return (
    <section className="bg-gradient-to-b from-green-50 to-white px-4 sm:px-6 md:px-16 py-16 font-poppins min-h-screen text-neutral-900">

      {/* Heading */}
      <div className="text-center mb-12">
        <h1 className="text-4xl md:text-6xl font-black text-green-900 tracking-wide">
          Contact Us
        </h1>
        <p className="mt-4 text-green-800 text-lg md:text-xl font-bold max-w-2xl mx-auto">
          Begin your natural healing and wellness journey with us.
        </p>
      </div>

      {/* Content Container */}
      <div className="max-w-5xl mx-auto">

        {/* Contact Card */}
        <div className="bg-white p-6 md:p-12 rounded-3xl shadow-2xl border border-green-100">

          {/* Contact Heading */}
          <h2 className="text-2xl md:text-3xl font-black mb-10 text-green-700 border-b border-green-100 pb-4 text-center md:text-left">
            Contact Information
          </h2>

          {/* Contact Details Grid */}
          <div className="space-y-10 leading-relaxed font-bold text-[16px] md:text-[18px]">

            {/* Address */}
            <div className="bg-green-50/40 p-5 rounded-2xl border border-green-100">
              <p className="font-black text-green-900 text-xl md:text-2xl flex items-center gap-2 mb-3">
                📍 <span>Address</span>
              </p>
              <p className="text-neutral-900 text-lg md:text-xl font-bold leading-relaxed">
                Universal Goodlife Ashram <br />
                Sivasailam, (Via) Alwarkurichi, <br />
                Tenkasi District, Tamil Nadu - 627412
              </p>
            </div>

            {/* Phone Section */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

              {/* Enquiry */}
              <div className="bg-green-50/40 p-5 rounded-2xl border border-green-100">
                <p className="font-black text-green-900 text-xl md:text-2xl flex items-center gap-2 mb-3">
                  📞 <span>For Enquiry</span>
                </p>
                <p className="text-neutral-900 text-lg md:text-xl font-black tracking-wide space-y-1">
                  <a href="tel:+919360869867" className="hover:text-green-700 block transition">+91 93608 69867</a>
                  <a href="tel:+917667613218" className="hover:text-green-700 block transition">+91 76676 13218</a>
                </p>
              </div>

              {/* Booking */}
              <div className="bg-green-50/40 p-5 rounded-2xl border border-green-100">
                <p className="font-black text-green-900 text-xl md:text-2xl flex items-center gap-2 mb-3">
                  📞 <span>For Booking</span>
                </p>
                <p className="text-neutral-900 text-lg md:text-xl font-black tracking-wide space-y-1">
                  <a href="tel:+919443043074" className="hover:text-green-700 block transition">+91 94430 43074</a>
                  <a href="tel:+916383403357" className="hover:text-green-700 block transition">+91 63834 03357</a>
                </p>
              </div>

            </div>

            {/* Email & Website Section */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              
              {/* Email */}
              <div className="bg-green-50/40 p-5 rounded-2xl border border-green-100">
                <p className="font-black text-green-900 text-xl md:text-2xl flex items-center gap-2 mb-2">
                  📧 <span>Email</span>
                </p>
                <a 
                  href="mailto:service@universalgoodlife.co.in" 
                  className="text-neutral-900 hover:text-green-700 text-lg md:text-xl font-bold break-all block underline decoration-green-300 underline-offset-4"
                >
                  universalgoodlifeahram1969@gmail.com
                </a>
              </div>

              {/* Website */}
              <div className="bg-green-50/40 p-5 rounded-2xl border border-green-100">
                <p className="font-black text-green-900 text-xl md:text-2xl flex items-center gap-2 mb-2">
                  🌐 <span>Website</span>
                </p>
                <a
                  href="http://www.universalgoodlife.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-neutral-900 hover:text-green-700 text-lg md:text-xl font-bold break-all block underline decoration-green-300 underline-offset-4"
                >
                  www.universalgoodlife.com
                </a>
              </div>

            </div>

            {/* Consulting & Alternate Location Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

              {/* Consulting Time */}
              <div className="bg-green-50/20 p-5 rounded-2xl border border-green-100/70">
                <p className="font-black text-neutral-900 text-xl md:text-2xl flex items-center gap-2 mb-3">
                  🕒 <span>Consulting Time</span>
                </p>
                <div className="text-neutral-900 text-base md:text-lg font-bold space-y-1">
                  <p><span className="text-green-800 font-black">Morning Session:</span> 9:30 AM - 1:00 PM</p>
                  <p><span className="text-green-800 font-black">Evening Session:</span> 6:00 PM - 8:00 PM</p>
                </div>
              </div>

              {/* Location Details */}
              <div className="bg-green-50/20 p-5 rounded-2xl border border-green-100/70">
                <p className="font-black text-neutral-900 text-xl md:text-2xl flex items-center gap-2 mb-3">
                  🗺️ <span>Location Desk</span>
                </p>
                <p className="text-neutral-900 text-base md:text-lg font-bold leading-relaxed">
                  Universal Goodlife Ashram, Sivasailam, <br />
                  Alwarkurichi, Tenkasi District - 627412
                </p>
              </div>

            </div>

            {/* Interactive Embedded Google Map */}
            <div className="mt-6 pt-4">
              <p className="font-black text-green-900 text-xl md:text-2xl flex items-center gap-2 mb-4">
                📌 <span>Find Us On Map</span>
              </p>
              <div className="rounded-2xl overflow-hidden shadow-xl border-2 border-green-100">
                <iframe
                  title="Universal Goodlife Ashram Route Map"
                  src="https://maps.google.com/maps?q=Universal%20Goodlife%20Ashram,%20Sivasailam&t=&z=13&ie=UTF8&iwloc=&output=embed"
                  width="100%"
                  height="380"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>

          </div>
        </div>

      </div>
    </section>
  );
}

export default Contact;